// Analytics rows are keyed by campaign id. These ids mean something to a person: an A/B test's two
// variants, the Marketing Studio's sends, a test send. Anything else keeps its id.
const FIXED = { studio: 'Marketing Studio sends', test_send: 'Test sends to yourself', bulk: 'Bulk sends', one_off: 'One-off emails' };

export function campaignLabel(campaignId, abTests = []) {
  for (const t of abTests) {
    if (t.campaign_a === campaignId) return `${t.name} — Variant A`;
    if (t.campaign_b === campaignId) return `${t.name} — Variant B`;
  }
  return FIXED[campaignId] || campaignId;
}
